import { ImageFeatureCard, type ImageFeatureCardProps } from "components/cards";
import { ThreeCardGrid } from "components/grids";
import React from "react";
import feature1Image from "../../../../public/assets/solutions/advertising/match-booster-feature-1.png";
import feature2Image from "../../../../public/assets/solutions/advertising/match-booster-feature-2.png";
import feature3Image from "../../../../public/assets/solutions/advertising/match-booster-feature-3.png";

export function MatchBoosterFeatures() {
  const features: ImageFeatureCardProps[] = [
    {
      image: feature1Image,
      title: "Increase audience reach and revenue lift",
      description:
        "Improve audience sizes by enhancing your audiences with our identity graph. Convert more with higher reach and waste less with better suppression.",
    },
    {
      image: feature2Image,
      title: "Maximize conversion performance",
      description:
        "Conversion signals are the real-time fuel for the ad platforms’ AI systems. Better signals improve budget allocation, bids, and targeting resulting in higher ROAS.",
    },
    {
      image: feature3Image,
      title: "Reach anonymous users, business users, and more",
      description:
        "Connect anonymous visits to known profiles, match business and personal identities, and expand your reach into entire households.",
    },
  ];

  return (
    <ThreeCardGrid>
      {features.map((feature) => (
        <ImageFeatureCard key={feature.title} {...feature} borderColor="mint" />
      ))}
    </ThreeCardGrid>
  );
}
